import React from 'react';
import s from './headline.module.scss';

export default function HeadlineComponent({
  h1,
  h2,
  h3,
  children,
  white,
  className,
  ...props
}) {
  if (h1) {
    return (
      <h1
        className={`
      ${s.headline}
      ${white && s.white}
      ${className}`}
        {...props}
      >
        {children}
      </h1>
    );
  }
  if (h2) {
    return (
      <h2
        className={`
      ${s.headline}
      ${white && s.white}
      ${className}`}
        {...props}
      >
        {children}
      </h2>
    );
  }
  if (h3) {
    return (
      <h3
        className={`
      ${s.headline}
      ${white && s.white}
      ${className}`}
        {...props}
      >
        {children}
      </h3>
    );
  }
  return (
    <h1
      className={`
  ${s.headline}
  ${white && s.white}
  ${className}`}
      {...props}
    >
      {children}
    </h1>
  );
}
